<template>
  <el-dialog
    :visible="visible"
    width="420px"
    title="提示"
    @close="visible = false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="copy-modal">
      <div class="copy-modal-content">
        <p :style="{ marginBottom: '10px' }">统计图表名称</p>
        <el-input
          ref="inputRef"
          :maxlength="100"
          placeholder="请输入统计图表名称"
          v-model="title"
          @keyup.enter.native="confirmHandle"
        />
      </div>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fetchMaxIndex } from '@/lib/utils';
import { services } from '@/service';
export default {
  data() {
    return {
      title: '',
      loading: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    courseDetail: {
      type: Object,
      required: true
    },
    researchModel: {
      type: Object,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.inputRef.focus();
    });
  },
  methods: {
    async confirmHandle() {
      if (this.loading) {
        return;
      }
      if (!this.title) {
        this.$message.warning('请输入课题名称');
        return;
      }
      try {
        this.loading = true;

        const charts = [...this.courseDetail._source.chart];
        const chartIndex = charts.findIndex(item => item.index_id === this.researchModel.index_id);

        const newChartItem = {
          ...this.researchModel,
          index_id: fetchMaxIndex(charts) + 1,
          title: this.title
        };

        charts.splice(chartIndex, 0, newChartItem);

        const newCourseSource = {
          ...this.courseDetail._source,
          chart: charts
        };

        await services.courseware.saveCourseware(this.courseDetail._id, newCourseSource);

        this.$emit('success', newCourseSource);
        this.$message.success('复制成功');

        services.logger.handleLog({
          operateName: '创建研究点',
          toPathName: 'caseResearch',
          apiUrl: '/nlp/case/update/case/chart/data'
        });
        if (newChartItem.type === 'tableAnalysisChart') {
          services.logger.handleLog({
            operateName: '创建高级模型',
            toPathName: 'caseResearch',
            apiUrl: '/nlp/case/update/case/chart/data'
          });
        }

        this.visible = false;
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.copy-modal {
}
</style>
